var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(791 2203)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(-791 -2203)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16055.746 -538.873)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.754,14a1.584,1.584,0,0,1-1.584,1.584h-9.5L4.5,18.754V6.084A1.584,1.584,0,0,1,6.084,4.5H17.17a1.584,1.584,0,0,1,1.584,1.584Z",
    transform: "translate(15268.246 -1660.627)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,19.754a1,1,0,0,1-1-1V6.084A2.587,2.587,0,0,1,6.084,3.5H17.17a2.587,2.587,0,0,1,2.584,2.584V14a2.587,2.587,0,0,1-2.584,2.584H8.082L5.207,19.461A1,1,0,0,1,4.5,19.754ZM6.084,5.5a.584.584,0,0,0-.584.584V16.34l1.46-1.46a1,1,0,0,1,.707-.293h9.5A.584.584,0,0,0,17.754,14V6.084A.584.584,0,0,0,17.17,5.5Z",
    transform: "translate(15268.246 -1660.627)",
    fill: "#494d7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H8a.5.5,0,0,1,.5.5A.5.5,0,0,1,8,.5Z",
    transform: "translate(15275.873 -1652.5)",
    fill: "#494d7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H8a.5.5,0,0,1,.5.5A.5.5,0,0,1,8,.5Z",
    transform: "translate(15275.873 -1650.5)",
    fill: "#494d7d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H8a.5.5,0,0,1,.5.5A.5.5,0,0,1,8,.5Z",
    transform: "translate(15275.873 -1648.5)",
    fill: "#494d7d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.4115aeaeb57d5cedb7a1682a918e6644.svg";
export { ForwardRef as ReactComponent };